import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';
import PrivateRoute from './components/PrivateRoute';
import Navigation from './components/Navigation';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CampaignList from './pages/CampaignList';
import CampaignWizard from './pages/CampaignWizard';
import CampaignDetail from './pages/CampaignDetail';
import Contacts from './pages/Contacts';
import ContactLists from './pages/ContactLists';
import ContactListDetail from './pages/ContactListDetail';
import Unsubscribe from './pages/Unsubscribe';
import TenantList from './pages/TenantList';
import TenantConfig from './pages/TenantConfig';
import UserList from './pages/UserList';
import Reports from './pages/Reports';
import ClientOverview from './pages/ClientOverview';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <Dashboard />
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <div className="container">
                    <CampaignList />
                  </div>
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/new"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <CampaignWizard />
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/:id"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <CampaignDetail />
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/:id/edit"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <CampaignWizard />
                </>
              </PrivateRoute>
            }
          />

          {/* Viber routes redirect into the unified wizard (channel pre-selected) */}
          <Route path="/campaigns/viber/new" element={<Navigate to="/campaigns/new?channel=viber" replace />} />
          <Route
            path="/campaigns/viber/:id/edit"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <CampaignWizard />
                </>
              </PrivateRoute>
            }
          />

          {/* Sent-messages overview ("Pregled poruka") */}
          <Route
            path="/messages"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <ClientOverview />
                </>
              </PrivateRoute>
            }
          />

          {/* Contacts routes */}
          <Route
            path="/contacts"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <Contacts />
                </>
              </PrivateRoute>
            }
          />

          {/* Contact Lists routes */}
          <Route
            path="/contact-lists"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <ContactLists />
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/contact-lists/:id"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <ContactListDetail />
                </>
              </PrivateRoute>
            }
          />

          {/* Super Admin routes */}
          <Route
            path="/admin/tenants"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <div className="container">
                    <TenantList />
                  </div>
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tenants/:id/config"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <div className="container">
                    <TenantConfig />
                  </div>
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <div className="container">
                    <UserList />
                  </div>
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <PrivateRoute>
                <>
                  <Navigation />
                  <div className="container">
                    <Reports />
                  </div>
                </>
              </PrivateRoute>
            }
          />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
};

export default App;
